export default {_name:'image.avatar.edit',module:'Field',view:'Element/Image/AvatarEdit',options:{key:'avatar'}}